import { FC } from 'react'
import * as styles from 'components/features/socialFeed/CommentListMeta/CommentListMeta.styl'
import { PostUid } from 'interfaces/feed'
import { createPluralFormatter } from 'helpers/formatHelpers'
import FeedPostCommentsOrdering from 'components/features/socialFeed/FeedPostCommentsOrdering/FeedPostCommentsOrdering'

type CommentListMetaProps = {
  commentsCount: number
  postUid: PostUid
}

const getPluralComments = createPluralFormatter('comment', 'comments')

export const CommentListMeta: FC<CommentListMetaProps> = (props) => {
  const { commentsCount, postUid } = props

  const commentsOrderingChild = commentsCount > 2 && (
    <div className={ styles.commentsOrderingWrapper }>
      <FeedPostCommentsOrdering postUid={ postUid } />
    </div>
  )

  return (
    <div className={ styles.commentListMeta }>
      <div className={ styles.commentsCountWrapper }>
        <span className={ styles.commentsCount }>{ commentsCount }</span>&nbsp;{ getPluralComments(commentsCount) }
      </div>
      { commentsOrderingChild }
    </div>
  )
}
